import { Params } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";

// enums
import { RANDOM_VALUE } from "src/app/core/enums/global/random-value";

class Pagination<T> {

    // fields
    public Params: Params = null
    private _limit: number = 5;
    private _totalCount: number = 0
    private _currentPage: number = 1
    private _items: Array<T> | any[] = []
    private _callback: (...arg: any[]) => void
    private _isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(
        _limit: number,
        totalCount: number,
        _currentPage: number,
        _callback: (...arg: any[]) => void | Observable<{[key: string]: any}>,
    ) {

        // init
        this.limit = _limit;
        this.totalCount = totalCount;
        this.currentPage = _currentPage;
        this.callBack = _callback;

        //
        this.initCallback();

    }

    // start Getters & setters

    /**
     * Array of item
     */
    public get items(): Array<T> {
        return this._items
    }

    private set items(value: Array<T>) {
        if (Array.isArray(value)) this._items = value
    }    

    /**
     * limit length of Array
     */
    public get limit(): number {
        return this._limit
    }

    public set limit(value: number) {
        if (!isNaN(value)) this._limit = value;
    }

    /**
     * total length of Array
     */
    public get totalCount(): number {
        return this._totalCount
    }

    public set totalCount(value: number) {
        if (!isNaN(value) && value >= 0) this._totalCount = value;
    }
    
    /**
     * current part of Array
     */
    public get currentPage(): number {
        return this._currentPage
    }

    public set currentPage(value: number) {
        if (!isNaN(value) && value >= 0) this._currentPage = value;
    }

    /**
     * total Arrays after pagination
     */
    public get totalPages(): number {
        return Math.ceil(this.totalCount / this.limit)
    }

    /**
     * callBack
     */
    public get callBack(): (...arg: any[]) => void | Observable<{[key: string]: any}> {
        return this._callback
    }

    public set callBack(fun: (...arg: any[]) => void | Observable<{[key: string]: any}>) {
        if (fun instanceof Function) this._callback = fun
    }
    
    /**
     * loading between start request & response
     */
    public get isLoading(): BehaviorSubject<boolean> {
        return this._isLoading
    }

    private set isLoading(value: any) {
        this._isLoading.next(value)
    }    

    // end Getters & setters


    // start Methods

    public initCallback(params?: Params): void {

        if (this.callBack instanceof Function) {

            // loader is start
            this.isLoading = true;

            //
            const caller = this.callBack({
                limit: this.limit,
                page: this.currentPage,
                ...params,
                ...this.Params
            })

            if (caller instanceof Observable) {

                caller.subscribe(
                    (res: any) => {

                    // ES6 destructuring
                    const { data, totalCount } = res || {}

                    //
                    this.items = data;
                    
                    //
                    this.totalCount = totalCount;

                    // loader is end
                    this.isLoading = false                    

                    } 
                );

            }

        }        
    }

    /**
     * increase & decrease Pages
     */
    public nextPage(): void {

        if (this.totalPages > this.currentPage) {
            this.currentPage += this.currentPage
        }
    }

    public previousPage(): void {
        if (this.currentPage > 0) this.currentPage -= this.currentPage
    }

    public pageChange(
        page: number,
        callBack?: (params?: Params) => void | Observable<{[key: string]: any}>,
        invocationMain: boolean = true
    ): void {

        // set
        this.currentPage = page

        // invocation
        /**
         * main callback
         */
        if (invocationMain) this.initCallback({[RANDOM_VALUE.loader]: false})

        /**
         * coming callback as arg
         */
        if (callBack instanceof Function)  {

            // loader is start
            this.isLoading = true            

            //
            const caller = callBack({
                limit: this.limit,
                page: this.currentPage,
                [RANDOM_VALUE.loader]: false,
                ...this.Params
            })

            if (caller instanceof Observable) {

                caller.subscribe(
                    (res: any) => {

                    // ES6 destructuring
                    const { data, totalCount } = res || {}

                    //
                    this.items = data;

                    //
                    this.totalCount = totalCount;

                    // loader is end
                    this.isLoading = false                    

                    } 
                );

            }            

        }

    }

    // end Methods


}

export default Pagination